import { mobileApi, mobileRequest } from './mobileApi';
import { getDeviceFingerprint } from '../../utils/deviceFingerprint';

export const mobileAuthService = {
  login: async (credentials) => {
    const deviceFingerprint = getDeviceFingerprint();
    const result = await mobileRequest(() =>
      mobileApi.post('/login', {
        ...credentials,
        deviceFingerprint
      })
    );

    if (result.success) {
      const user = result.data.user || result.data;
      const requiresOtp = user.requiresOtp ?? user.RequiresOtp ?? true;

      if (!requiresOtp) {
        const token = user.token || user.Token || result.data.token;
        if (token) {
          localStorage.setItem('mobileToken', token);
          localStorage.setItem('mobileUser', JSON.stringify(user));
        }
      }

      return { ...result, requiresOtp };
    }

    return result;
  },

  verifyOtp: async ({ email, password, otp, trustDevice = false }) => {
    const deviceFingerprint = getDeviceFingerprint();
    const result = await mobileRequest(() =>
      mobileApi.post('/VerifyOtp', {
        email,
        password,
        otp,
        deviceFingerprint,
        trustDevice
      })
    );

    if (result.success) {
      const user = result.data.user || result.data;
      const token = user.token || user.Token || result.data.token;

      if (token) {
        localStorage.setItem('mobileToken', token);
        localStorage.setItem('mobileUser', JSON.stringify(user));
      }
    }

    return result;
  },

  resendOtp: async (email) => {
    return mobileRequest(() =>
      mobileApi.post('/ResendOtp', { email })
    );
  },

  logout: () => {
    localStorage.removeItem('mobileToken');
    localStorage.removeItem('mobileUser');
  },

  getUser: () => {
    const userStr = localStorage.getItem('mobileUser');
    return userStr ? JSON.parse(userStr) : null;
  },

  // Per-user module permissions (fail-open: errors -> feature disabled = full access)
  getMyPermissions: async () => {
    try {
      const response = await mobileApi.get('/users/me/permissions');
      const responseData = response.data;
      const data = responseData.Data || responseData.data || responseData;
      return {
        enabled: data.Enabled ?? data.enabled ?? false,
        role: data.Role ?? data.role ?? '',
        permissions: data.Permissions ?? data.permissions ?? null,
      };
    } catch (error) {
      return { enabled: false, role: '', permissions: null };
    }
  },

  isAuthenticated: () => {
    return !!localStorage.getItem('mobileToken');
  }
};
